.rule-import2 {
	background: red !important;
}


/** WEBPACK FOOTER **
 ** ./loaders/_css/folder/stylesheet-import3.css
 **/